import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { filter, map, tap, withLatestFrom, take, switchMap } from 'rxjs/operators';
import { SharedTranslationConfig } from '../../../_config/translation/shared/shared.translation.config';
import { ResourceStringMap } from '../../models/models-index';
import { Store } from '@ngrx/store';
import { AppState } from '../../../_store/app-state.model';
import { AppSelectors } from '../../../_store/selector-types';

@Injectable()
export class SharedTranslationService implements OnDestroy {
  sharedTranslations = new SharedTranslationConfig;
  appSectionTranslations: any;
  navLabelTranslations: any;  
  resourceStringMap: ResourceStringMap;
  subscriptions: Subscription[] = [];

  constructor(
    private store$: Store<AppState>
  ) {
    this.subscriptions.push(this.store$.select(AppSelectors.selectConfigState).pipe(
      filter(config => !!config),
      map(config => {
        return config.resourceStrings;
      })
    ).subscribe(rs => {
      this.resourceStringMap = rs;
    }))
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe())
  }

  getLabelTranslation(value: string, locale?: string): string {
    const v4locale = locale == 'en-US' ? 'en' : locale;
    const v5locale = locale == 'en' ? 'en-US' : locale;
    const key = value?.toLowerCase().replace(/[^A-Z0-9]+/ig, '');

    const v4result = this.sharedTranslations?.labels?.[v4locale]?.[key];
    const v5result = this.resourceStringMap?.[v5locale]?.[key];

    //console.log(value, locale, '|', key, '|', v5result, v4result);

    return v5result || v4result || value || null;
  }
}

